/* <predictive-search> — combobox-lite predictive search.
   Progressive enhancement: the form works natively (submits to /search)
   without this script. Fetch logic only runs once the visitor types. */
if (!customElements.get('predictive-search')) {
  customElements.define(
    'predictive-search',
    class PredictiveSearch extends HTMLElement {
      constructor() {
        super();
        this.dialog = this.querySelector('dialog');
        this.input = this.querySelector('[data-search-input]');
        this.list = this.querySelector('[data-results-list]');
        this.results = this.querySelector('[data-results]');
        this.emptyEl = this.querySelector('[data-empty]');
        this.viewAll = this.querySelector('[data-view-all]');
        this.emptyTemplate = this.results.dataset.emptyTemplate || '';
        this.predictiveUrl = this.dataset.predictiveUrl;
        this.searchUrl = this.dataset.searchUrl;
        this.activeIndex = -1;
        this.timer = null;
        this.invoker = null;

        this.querySelectorAll('[data-search-close]').forEach((btn) =>
          btn.addEventListener('click', () => this.close())
        );
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.close();
        });
        this.dialog.addEventListener('close', () => {
          if (this.invoker) this.invoker.focus();
        });
        this.input.addEventListener('input', () => this.onInput());
        this.input.addEventListener('keydown', (event) => this.onKeydown(event));
        document.addEventListener('search:open', () => this.open());
      }

      open() {
        this.invoker = document.activeElement;
        if (typeof this.dialog.showModal === 'function') this.dialog.showModal();
        this.input.focus();
        this.input.select();
      }

      close() {
        if (this.dialog.open) this.dialog.close();
      }

      onInput() {
        clearTimeout(this.timer);
        const q = this.input.value.trim();
        if (q.length < 2) {
          this.clear();
          return;
        }
        this.timer = setTimeout(() => this.fetchResults(q), 250);
      }

      async fetchResults(q) {
        try {
          const url = `${this.predictiveUrl}.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6`;
          const response = await fetch(url);
          const data = await response.json();
          this.render(data?.resources?.results?.products || [], q);
        } catch (error) {
          this.clear();
        }
      }

      render(products, q) {
        this.activeIndex = -1;
        this.list.innerHTML = '';

        if (!products.length) {
          this.list.hidden = true;
          this.viewAll.hidden = true;
          this.emptyEl.hidden = false;
          this.emptyEl.textContent = this.emptyTemplate.replace('__TERMS__', q);
          this.input.setAttribute('aria-expanded', 'false');
          this.input.removeAttribute('aria-activedescendant');
          return;
        }

        this.emptyEl.hidden = true;

        products.forEach((product, index) => {
          const li = document.createElement('li');
          li.setAttribute('role', 'option');
          li.id = `PredictiveSearch-option-${index}`;
          li.className = 'search-dialog__item';

          const thumb = product.featured_image
            ? `<img src="${product.featured_image.url}&width=96" width="48" height="48" alt="" loading="lazy">`
            : '';

          const a = document.createElement('a');
          a.href = product.url;
          a.tabIndex = -1;
          a.innerHTML = `${thumb}<span>${product.title.split(' \u2014 ')[0]}</span>`;
          li.append(a);
          this.list.append(li);
        });

        this.list.hidden = false;
        this.viewAll.href = `${this.searchUrl}?q=${encodeURIComponent(q)}&type=product`;
        this.viewAll.hidden = false;
        this.input.setAttribute('aria-expanded', 'true');
      }

      clear() {
        this.list.innerHTML = '';
        this.list.hidden = true;
        this.viewAll.hidden = true;
        this.emptyEl.hidden = true;
        this.input.setAttribute('aria-expanded', 'false');
        this.input.removeAttribute('aria-activedescendant');
        this.activeIndex = -1;
      }

      onKeydown(event) {
        const items = this.list.querySelectorAll('[role="option"]');
        if (!items.length) return;

        if (event.key === 'ArrowDown') {
          event.preventDefault();
          this.activeIndex = (this.activeIndex + 1) % items.length;
          this.setActive(items);
        } else if (event.key === 'ArrowUp') {
          event.preventDefault();
          this.activeIndex = (this.activeIndex - 1 + items.length) % items.length;
          this.setActive(items);
        } else if (event.key === 'Enter' && this.activeIndex > -1) {
          event.preventDefault();
          items[this.activeIndex].querySelector('a').click();
        }
      }

      setActive(items) {
        items.forEach((el, i) => el.classList.toggle('is-active', i === this.activeIndex));
        this.input.setAttribute('aria-activedescendant', items[this.activeIndex].id);
      }
    }
  );
}
